import React, { useEffect, useState } from "react";
import {
  DeleteBlogsCatorgeries,
  getAllBlogCategoriesList,
} from "services/apiService";
import DynamicButton from "../../../common/DynamicButton.jsx";
import {
  faCirclePlus,
  faMagnifyingGlass,
  faPen,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import CommonTable from "common/CommonTable";
import loadingImage from "../../../assect/loadingSvg/loading.svg";
import Swal from "sweetalert2";
import { Button } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BlogCategoryEdit from "./BlogCategoryEdit";
import BlogCategoryCreate from "./BlogCategoryCreate";

const BlogCategory = () => {
  const [blogcategorySearch, setBlogCategorySearch] = useState("");
  const [blogCategoryData, setBlogCategoryData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [isOpenSubPageEdit, setIsOpenSubpagesEdit] = useState<boolean>(false);
  const [isOpenSubPageCreate, setisOpenSubPageCreate] =
    useState<boolean>(false);
  const [selectedSubPagesId, setSelectedSubpagesId] = useState<number | null>(
    null
  );
  const headers = ["S.no", "Blog Category Name", "Status", "Action"];

  useEffect(() => {
    getallBlogsCategoriesData();
  }, []);

  const getallBlogsCategoriesData = async () => {
    setLoader(true);
    try {
      const response = await getAllBlogCategoriesList();
      setBlogCategoryData(response.data);
    } catch (error) {
      console.error("Error fetching blog categories:", error);
    } finally {
      setLoader(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setBlogCategorySearch(value);
  };

  const filteredCategories = blogCategoryData?.filter((category) =>
    category.name.toLowerCase().includes(blogcategorySearch.toLowerCase())
  );

  const handleDelete = async (id: number, name: string) => {
    try {
      const firstConfirmation = await Swal.fire({
        title: "Are you sure?",
        html: `You wanted to delete <strong style="color: orange; padding: 3px;">⚠️ ${name}</strong>`,
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
      });
      if (firstConfirmation.isConfirmed) {
        const secondConfirmation = await Swal.fire({
          title: "Are you really sure?",
          text: "This action cannot be undone!",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Yes, I am sure!",
          cancelButtonText: "Cancel",
        });

        if (secondConfirmation.isConfirmed) {
          const response = await DeleteBlogsCatorgeries(id);
          if (response.status_code === 200) {
            Swal.fire(
              "Deleted!",
              "The Blog Categories has been deleted.",
              "success"
            );
            getallBlogsCategoriesData();
          } else {
            Swal.fire("Error!", "Something went wrong!", "error");
          }
        } else {
          Swal.fire("Cancelled", "The Blog Categories is safe!", "info");
        }
      }
    } catch (error) {
      Swal.fire("Error!", "An unexpected error occurred.", "error");
    }
  };

  const handleModelOpen = (id: number) => {
    setSelectedSubpagesId(id);
    setIsOpenSubpagesEdit(true);
  };

  const handleModelClose = () => {
    setIsOpenSubpagesEdit(false);
  };

  const handleModelCloseCreate = () => {
    setisOpenSubPageCreate(false);
  };

  const renderRow = (blog: any, index: number) => {
    return (
      <tr className="mt-2 pt-4" key={index}>
        <td>{index + 1}</td>
        <td title={blog.name}>
          {blog.name?.length > 30 ? blog.name?.slice(0, 30) + "..." : blog.name}
        </td>
        <td
          className={`fw-semibold ${
            blog.is_active === 1 ? "text-success" : "text-danger"
          }`}
        >
          {blog.is_active === 1 ? "Active" : "Inactive"}
        </td>
        <td className="align-content-center">
          <div className="actions-buttons">
            <DynamicButton
              icon={faPen}
              onClick={() => handleModelOpen(blog.id)}
              iconStyle={{ color: "#63E6BE" }}
              style={{
                padding: "0",
                border: "none",
                background: "none",
                cursor: "pointer",
                margin: "2px",
              }}
            />
            <DynamicButton
              icon={faTrash}
              iconStyle={{ color: "red" }}
              style={{
                padding: "0",
                border: "none",
                background: "none",
                cursor: "pointer",
                margin: "2px",
              }}
              onClick={() => handleDelete(blog.id, blog.name)}
            />
          </div>
        </td>
      </tr>
    );
  };

  return (
    <>
      <div className="d-flex justify-content-between">
        <div className="col-lg-6">
          <Button
            onClick={() => setisOpenSubPageCreate(true)}
            variant="contained"
            color="primary"
            sx={{ borderRadius: "0px" }}
          >
            <FontAwesomeIcon
              icon={faCirclePlus}
              style={{ marginRight: "10px" }}
            />
            Create Blog Category
          </Button>
        </div>
        <div className="col-lg-5 d-flex mb-3">
          <input
            type="text"
            className="form-control"
            value={blogcategorySearch}
            placeholder="Search Blog Categories"
            style={{ boxShadow: "none" }}
            onChange={handleChange}
          />
          <div className="input-group-append">
            <span className="input-group-text">
              <FontAwesomeIcon icon={faMagnifyingGlass} size="xl" />
            </span>
          </div>
        </div>
      </div>
      <div className="product-table-container">
        <div className="product-table-content">
          {loader ? (
            <div className="loadingsvg-Image text-center">
              <img
                src={loadingImage}
                width={150}
                height={150}
                alt="Loading..."
              />
            </div>
          ) : (
            <CommonTable
              data={filteredCategories}
              isLoading={loader}
              headers={headers}
              renderRow={renderRow}
            />
          )}
        </div>
      </div>
      <BlogCategoryEdit
        onActionComplete={() => {
          getallBlogsCategoriesData();
        }}
        open={isOpenSubPageEdit}
        handleClose={handleModelClose}
        id={selectedSubPagesId}
      />
      <BlogCategoryCreate
        open={isOpenSubPageCreate}
        handleClose={handleModelCloseCreate}
        onActionComplete={() => {
          getallBlogsCategoriesData();
        }}
      />
    </>
  );
};

export default BlogCategory;
